/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // Nav bar
        var navBarVisible = false;
        $('#toggleNavBarPages').click(function () {
          if (navBarVisible) {
            $('#navBarPages').slideUp();
          } else {
            $('#navBarPages').slideDown();
          }
          navBarVisible = !navBarVisible;
        });

        // Newsletter sign up modal
        var cookieName = 'blog-newsletter-signup-form-modal';
        $('#newsletter-signup-form-modal').find('.close').on('click', function () {
          $('#newsletter-signup-form-modal').modal('hide');
        });
        $('#newsletter-signup-form-modal').find(':submit').on('click', function () {
          Cookies.remove(cookieName);
        });
        if (!Cookies.get(cookieName)) {
          $('#newsletter-signup-form-modal').modal('show');
          Cookies.set(cookieName, 'true');
        }
        $('.newsletter-popup').on('click', function (e) {
          /*console.log(e);*/
          e.preventDefault();
          $('#newsletter-signup-form-modal').modal('show');
        });

        // Most popular carousel
        $('#popular-now-widget').slick({
            arrows: true,
            slidesToShow: 2,
            prevArrow: '.popular-now-nav-left',
            nextArrow: '.popular-now-nav-right',
            touchThreshold: 100,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 426,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        // subscribeCustomerForm
        $('.newsletter-signup-form-widget .subscribeCustomerForm').submit(function subscribeCustomerFormSubmit(event) {
          var alertSuccess = $('.alert-success', event.target);
          var alertDanger = $('.alert-danger', event.target);
          var formContent = $('.form-content', event.target);
          var loader = $('.loader', event.target);

          formContent.hide();
          alertDanger.hide();
          loader.show();

          var subscribeCustomerFormData = jQuery(this).serialize();
          jQuery.ajax({
            type:"POST",
            url: "/blog/wp/wp-admin/admin-ajax.php?action=subscribeCustomer",
            data: subscribeCustomerFormData,
            dataType: 'json',
            success: function(data) {
              loader.hide();
              if (data === true) {
                  alertSuccess.html('Thanks for signing up!').show();
                  dataLayer.push({
                    'event' : 'subscribe-form-submitted'
                  });
              } else {
                if (typeof data.message !== 'undefined') {
                  alertDanger.html(data.message).show();
                } else {
                  alertDanger.html("Oops, we're having some trouble signing up your email. Please try again.").show();
                }
                formContent.show();
              }
            }
          });

          return false;
        });

          /* SUBMIT THE DESKTOP SEARCH FORM & APPEND THE KEYWORD */
          $('#navbar-form').on('submit', function (e) {
              var domain = $('#navbar-form').attr('action'),
                  keyword = $('#search-input').attr('value');
              $('#navbar-form').attr("action", domain + keyword);
          });
          /* SUBMIT THE MOBILE SEARCH FORM & APPEND THE KEYWORD */
          $('#mobile-search-form').on('submit', function (e) {
              var domain = $('#mobile-search-form').attr('action'),
                  keyword = $('#mobile-search-input').attr('value');
              $('#mobile-search-form').attr("action", domain + keyword);
          });

          /* OPEN THE DESKTOP SEARCH FORM & HIDE THE MENU */
          $( '#search-button' ).on( 'click', function( e ) {
              // Cancels the default actions.
              e.stopPropagation();
              e.preventDefault();

              //console.log($( this ));
              $('.housekeeping-nav .navbar-icon').hide();
              $( this ).parent().find( 'form.navbar-form' ).animate( { width: '100%' }, 0 );
              $( this ).parent().addClass( 'open active-search' );

              $( 'form.navbar-form input#search-input' ).val('');
              $( 'form.navbar-form input#search-input' ).focus();
          });

          /* OPEN THE MOBILE SEARCH FORM */
          $( '#mobilesearch-button' ).on( 'click', function( e ) {
              // Cancels the default actions.
              e.stopPropagation();
              e.preventDefault();

              // console.log($( this ));
              $('.mobile-search-wrapper').show();
              $('.mobile-search-wrapper').addClass( 'open active-search' );
              $( 'form.mobile-search-form' ).animate( { width: '100%' }, 0 );

              $( 'form.mobile-search-form input#mobile-search-input' ).val('');
              $( 'form.mobile-search-form input#mobile-search-input' ).focus();
          });


          $( window ).on( 'click', function( e ) {

              if( !$(e.target).is('input#search-input') ) {

                  /* CLOSE THE DESKTOP SEARCH FORM & SHOW THE MENU */
                  if ( $( '.housekeeping-nav' ).hasClass( 'active-search' ) ) {
                      $( 'form.navbar-form' ).animate(
                          { width: '0' }, 50, function() {
                              $( '.housekeeping-nav' ).removeClass( 'active-search' );
                              $( '.housekeeping-nav' ).removeClass( 'open' );
                              $('.housekeeping-nav .navbar-icon').show();
                          }
                      );
                  };

                  /* CLOSE THE MOBILE SEARCH FORM */
                  if ( $( '.mobile-search-wrapper' ).hasClass( 'active-search' ) ) {
                      $( 'form.mobile-search-form' ).animate(
                          { width: '0' }, 50, function() {
                              $( '.mobile-search-wrapper' ).removeClass( 'active-search' );
                              $( '.mobile-search-wrapper' ).removeClass( 'open' );
                              $('.mobile-search-wrapper').hide();
                          }
                      );
                  };

              }

          });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
